export default __webpack_public_path__ + "static/property-img2-f3223d028cad9b45fcc2fddb5f35a4f7.jpg";